import script from "./WidgetHeaderHome.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetHeaderHome.vue?vue&type=script&setup=true&lang=js"

import "./WidgetHeaderHome.vue?vue&type=style&index=0&id=2c6a3f8a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6a3f8a"]])

export default __exports__